import React, { FC, MutableRefObject, ReactNode } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import { NativeModalActions, useNativeModalActions } from '@Components/Modal/NativeModal/NativeModal'
import { ProductSidePaneLayout } from '@Domains/Product/Features/Display/ProductSidePaneLayout/ProductSidePaneLayout'

import styles from './AccordionSidePane.module.scss'

type AccordionSidePaneProps = {
  actionRef?: MutableRefObject<NativeModalActions | null>
  children?: ReactNode
  onOpen?: () => void
  prerender?: boolean
  title: ReactNode
  triggerTitle?: ReactNode
}
/**
 * @deprecated Use a NativeModal with alignment or create correct Accordion
 */
export const AccordionSidePane: FC<AccordionSidePaneProps> = ({
  actionRef,
  children,
  onOpen,
  prerender,
  title,
  triggerTitle,
}) => {
  const nativeRef = useNativeModalActions()
  const ref = actionRef || nativeRef

  return (
    <div className={styles.wrapper}>
      <button className={styles.trigger} onClick={() => ref.current?.open()} type="button">
        {triggerTitle || title}
        <SvgAngleRight className={styles.icon} />
      </button>

      <ProductSidePaneLayout
        actionRef={ref}
        onOpen={onOpen}
        prerender={prerender}
        title={title}
      >
        <div className={styles.content}>
          {children}
        </div>
      </ProductSidePaneLayout>
    </div>

  )
}

